import React, { useState, useEffect } from 'react';
import { Create, List, Datagrid, TextField, required, regex, EmailField, TextInput, Filter, NumberField, FunctionField, Edit, SimpleForm, EditButton, Show, SimpleShowLayout, ShowButton, ArrayField, RefreshButton, ReferenceField, SaveButton, Toolbar, usePermissions } from 'react-admin';
import { cloneElement } from 'react';
import {
    useListContext,
    TopToolbar,
    ExportButton,
    sanitizeListRestProps,
    CreateButton,
    SelectInput,
    PasswordInput,
    ReferenceInput
} from 'react-admin';
import DeleteButtonWithConfirmation from '../buttons/deleteButtonWithConfirmation'
import DeletePermButtonWithConfirmation from '../buttons/deletePermButtonWithConfirmation'
import UnDeleteButtonWithConfirmation from '../buttons/UndeleteButtonWithConfirmation'
import ButtonPassForm from '../buttons/sendPasswordForm';
import ButtonVerifyForm from '../buttons/sendVerifyForm';
import PermitsList from '../permits/permitsList';

const styles = {
    div1: {
        display: 'block',
        width: "25%",
        float: "left",
        position: "flex",
        marginRight: "10px"
    },
    div1Mobile: {
        display: 'block',
        width: "50%",
        float: "left",
        position: "flex",
        marginLeft: "2%",
        marginRight: "2%"
    },
    div2: {
        display: 'block',
        width: "73%",
        float: "left",
        position: "flex",
    },
    div2Mobile: {
        display: 'block',
        width: "100%",
        float: "left",
        marginLeft: "2%",
        marginRight: "2%",
        marginTop: "2%",
        position: "flex"
    },
    table: {
        overflowX: "auto"
    }
};


const PersonalTitle = ({ record, optionTitle }) => {
    if (optionTitle) {
        return ""
    }
    return <span>Personal - {record ? `${record.firstname} ${record.lastname}` : ''}</span>;
};

const ShowActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        basePath,
        data,
        resource,
        ...rest
    } = props;
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    if (!props.right) {
        return (<p></p>);
    }
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {(permissions.includes("transactions.list")) ?
                <RefreshButton label="Buscar transacciones" />
                : null}
            {(permissions.includes("personal.validate")) &&
                (data !== undefined && !(data.validated || (!data.validated && data.balance !== null))) ? <ButtonVerifyForm record={data} label="Enviar link confirmación" /> : null
            }
            {(permissions.includes("personal.change_pass")) &&
                <ButtonPassForm basePath={basePath} record={data} label="Cambiar contraseña" />
            }
            {(permissions.includes("personal.edit")) ?
                <EditButton basePath={basePath} record={data} label="Editar" />
                : null}
            {((data !== undefined && !data.blocked && permissions.includes("personal.block")) ?
                <DeleteButtonWithConfirmation basePath={basePath} record={data} resource={resource} undoable={false} label="Bloquear" />
                : <></>)}
            {((data !== undefined && data.blocked && permissions.includes("personal.block")) ?
                <UnDeleteButtonWithConfirmation basePath={basePath} record={data} resource={resource} undoable={false} label="Desbloquear" />
                : <></>)}
            {(permissions.includes("personal.delete")) ?
                <DeletePermButtonWithConfirmation basePath={basePath} record={data} resource={resource} undoable={false} label="Eliminar" />
                : null}
        </TopToolbar>
    );
};

const EditActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        basePath,
        data,
        resource,
        permissions,
        ...rest
    } = props;
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            <ShowButton basePath={basePath} record={data} label="Ver personal" />
        </TopToolbar>
    );
};

const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        basePath,
        maxResults,
        ...rest
    } = props;
    const {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        showFilter,
        total,
    } = useListContext();
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            {(permissions.includes("personal.create")) &&
                <CreateButton basePath={basePath} label="Crear" />
            }
            {(permissions.includes("personal.export")) &&
                <ExportButton
                    label="Exportar csv"
                    disabled={total === 0}
                    resource={resource}
                    sort={currentSort}
                    filterValues={filterValues}
                    maxResults={maxResults}
                />
            }
        </TopToolbar>
    );
};

export const PersonalList = props => (
    <List filters={<PersonalFilter />} {...props} bulkActionButtons={false} title="Personal" actions={<ListActions />}>
        <Datagrid rowClick="show">
            <ShowButton label="Ver" />
            <FunctionField label="Nombre completo" render={record => `${record.firstname} ${record.lastname}`} />
            <TextField source="username" label='Usuario' />
            <EmailField source="email" label='Correo electrónico' />
            <NumberField source="balance" label='Balance actual' />
            <FunctionField label="Validada" render={record => (record.validated || (!record.validated && record.balance !== null)) ? 'Sí' : 'No'} />
            <TextField source="createdAt" label="Fecha creación" />
            <EditButton label="Editar" />
        </Datagrid>
    </List>
);

const PersonalEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);

export const PersonalEdit = props => {
    return (
        <Edit title={<PersonalTitle />} {...props} resource={"users"} actions={<EditActions />} >
            <SimpleForm toolbar={<PersonalEditToolbar />} >
                <TextInput source="firstname" label="Nombre" />
                <TextInput source="lastname" label="Apellido" />
            </SimpleForm>
        </Edit>
    )
};

export const PersonalCreate = props => (
    <Create title={<PersonalTitle optionTitle={true} />} {...props} resource={"users"}>
        <SimpleForm submitOnEnter={false} toolbar={<PersonalEditToolbar />} >
            <TextInput helperText={"Entre 2 y 30 caracteres, sin espacios y sin caracteres especiales. "} validate={[required(), regex(/^^[a-zA-Z0-9_]{2,31}$/)]} source="username" label="Usuario" inputProps={{ autocomplete: 'off' }} />
            <TextInput helperText={"Entre 2 y 40 caracteres."} validate={[required(), regex(/^^[a-zA-ZñÑ0-9 -]{2,41}$/)]} source="name" label="Nombre" />
            <TextInput helperText={"Entre 2 y 40 caracteres."} validate={[required(), regex(/^^[a-zA-ZñÑ0-9 -]{2,41}$/)]} source="lastname" label="Apellido" />
            <TextInput helperText={"Debe ser un correo único."} validate={[required(), regex(/^^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]} source="email" label='Correo electrónico' type="email" />
            <PasswordInput helperText={"Al menos 8 caracteres entre mayúsculas, minúsculas y números."} validate={[required(), regex(/^^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,50}$/)]} source="password" label='Contraseña' inputProps={{ autocomplete: 'off' }} />
            <SelectInput validate={[required()]} defaultValue="tecnico" source="userType" label="Tipo de usuario" choices={[
                { id: 'tecnico', name: 'Personal' },
            ]} />
        </SimpleForm>
    </Create>
);

export const PersonalShow = props => {
    let roles = {
        user: 'Usuario',
        USER: 'Usuario',
        tech: 'Técnico',
        TECH: 'Técnico',
        postgres: 'Usuario',
        ASEO: "Aseo",
        SUPER_ADMIN: "Super administrador",
        ADMIN: "Administrador",
        FINANZAS: "Finanzas",
        PERSONALIZADO: "Personalizado"
    };

    const [width, setWindowWidth] = useState(0)

    useEffect(() => {

        updateDimensions();

        window.addEventListener("resize", updateDimensions);
        return () =>
            window.removeEventListener("resize", updateDimensions);
    }, [])
    const updateDimensions = () => {
        const width = window.innerWidth
        setWindowWidth(width)
    }

    const responsive = {
        web: width > 1023
    }

    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <div>
            <div style={(responsive.web) ? styles.div1 : styles.div1Mobile}>
                <Show title={<PersonalTitle />} {...props} resource={"users"} actions={<ShowActions right={false} />} >
                    <SimpleShowLayout>
                        <EmailField source="email" label='Correo electrónico' type="email" />
                        <TextField source="username" label='Usuario' />
                        <FunctionField label="Rol" render={record => (record.role) ? roles[record.role] : record.role} />
                        {(permissions.includes("transactions.list")) ?
                            <ReferenceField source="lastTransaction" label='Última transacción' reference="transactions">
                                <FunctionField label="Tipo de transacción" render={record => `${record.transactionType.toUpperCase()} - $${record.amount} - ${record.createdAt}`} link="show" />
                            </ReferenceField >
                            : null}
                        <NumberField source="balance" label='Balance actual' />
                        <FunctionField label="Validada" render={record => (record.validated || (!record.validated && record.balance !== null)) ? 'Sí' : 'No'} />
                    </SimpleShowLayout>
                </Show>
            </div>
            <div style={(responsive.web) ? styles.div2 : styles.div2Mobile}>
                {(permissions.includes("permits.list")) ?
                    <Show title={<PersonalTitle optionTitle={true} />} {...props} resource={"users"} actions={<ShowActions right={true} />} >
                        <SimpleShowLayout>
                            <PermitsList permissions_logged_user={permissions} />
                        </SimpleShowLayout>
                    </Show>
                    : null}
                <Show title={<PersonalTitle optionTitle={true} />} {...props} resource={"users"} actions={<ShowActions right={permissions.includes("permits.list") ? false : true} />} >
                    <SimpleShowLayout>
                        {(permissions.includes("transactions.list")) ?
                            <ArrayField source="transactions" label="Transacciones (se muestran las últimas 25 transacciones)">
                                <Datagrid>
                                    {/* <NumberField source="transactionId" label="Id" /> */}
                                    <TextField source="amount" label="Monto" />
                                    <TextField source="machineId" label="Máquina" />
                                    <FunctionField render={record => {
                                        if (record.role === 'USER' || record.role === 'postgres') {
                                            return `${record.transactionType.toUpperCase()}`;
                                        } else {
                                            if (record.transactionType === 'pago') {
                                                return 'USO PERSONAL';
                                            }
                                            return `${record.transactionType.toUpperCase()}`;
                                        }
                                    }} label="Tipo de transacción" />
                                    <TextField source="createdAt" label="Fecha" />
                                    <NumberField source="balance" label="Balance al momento" />
                                </Datagrid>
                            </ArrayField>
                            : null}
                        {(permissions.includes("transactions.list")) ?
                            <button onClick={() => props.history.push(`/transactions?page=1&perPage=25&filter={"userId":"${props.id}"}`)}>Mostrar más transacciones</button>
                            : null}

                    </SimpleShowLayout>
                </Show>
            </div>
        </div>
    )
};

const PersonalFilter = (props) => {
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <Filter {...props}>
            <TextInput label="Buscar" source="q" alwaysOn />
            {(permissions.includes("roles.list")) &&
                <ReferenceInput validate={[required()]} source="role" label='Rol' reference="roles" perPage={200}
                    sort={{ field: 'role', order: 'ASC' }}
                >
                    <SelectInput optionText="role" optionValue="role" />
                </ReferenceInput>
            }
        </Filter>
    )
};
